module.exports = __webpack_public_path__ + "fontawesome-webfont-v=4.4.0.45c73723862c6fc5eb3d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/font-awesome/fontawesome-webfont-v=4.4.0.eot
// module id = 375
// module chunks = 2